import React from 'react';
import { useI18n } from '../../../i18n';

export default function MobileWelcome() {
  const { t } = useI18n();

  return (
    <div className="login-mobile-welcome">
      <div className="login-mobile-wordmark">
        <img src="/logo_black.webp" width="48" height="36" alt="" fetchPriority="high" />
        <span>MY<span>KART</span></span>
      </div>

      <div className="login-mobile-intro">
        <svg className="login-mobile-circuit" viewBox="0 0 260 200" fill="none" aria-hidden="true">
          <path d="M275 18H180c-22 0-34 14-34 32v18c0 16 12 26 29 26h16c20 0 32 13 32 30s-12 30-32 30H92c-19 0-32 13-32 31v30" />
          <path d="M275 29H180c-15 0-23 9-23 21v18c0 9 7 15 18 15h16c27 0 43 18 43 41s-16 41-43 41H92c-12 0-21 9-21 20v30" />
          <path className="login-mobile-circuit-line" d="M275 18H180c-22 0-34 14-34 32v18" />
        </svg>
        <div className="login-start-grid" aria-hidden="true"><span/><span/><span/><span/><span/></div>
        <h1>{t('loginMobile.headlineFirst')}<br/><em>{t('loginMobile.headlineSecond')}</em></h1>
      </div>

    </div>
  );
}
